// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
#    Colors
   ========================================================================== */
/*\$mainColor:#d40621;
\$alphaLight:rgba(#fff, .5);
\$alphaDark:rgba(#000, .5);
\$placeholderTextLight:rgba(#fff, .7);
\$placeholderTextDark:rgba(#000, .7);

\$textLight: #fff;
\$textDark: #404040;
\$textThemes:#d40621;*/
/* ################## */
/* ################## */
/* ################## */
/* ################## */
dynamic-form {
  display: block;
  margin-bottom: var(--m_relatedContents);
  border-radius: 0;
  padding: 0;
  word-break: break-all;
}
dynamic-form h1,
dynamic-form h2,
dynamic-form h3 {
  color: var(--c_textBody);
}
dynamic-form .head {
  word-break: normal;
  background: var(--c_backgroundBox);
  border-radius: 4px;
  padding: 20px 40px;
  margin-bottom: var(--m_relatedContents);
  text-align: center;
}
dynamic-form .page {
  background: var(--c_backgroundBox);
  border-radius: 4px;
  padding: 20px 40px;
}
dynamic-form .page h2 {
  text-align: left;
}
dynamic-form .question {
  margin: 40px 0;
  word-break: normal;
}
dynamic-form .question .row.input {
  padding-left: 20px;
}
dynamic-form .question h3 {
  font-size: 1.25em;
  font-weight: 300;
}
dynamic-form .question h3 span {
  font-size: 1.5em;
  font-weight: normal;
}
dynamic-form .question.customValidation {
  position: relative;
}
dynamic-form .question.customValidation span.error {
  display: none;
  position: absolute;
  bottom: -15px;
  font-size: 0.8em;
  font-weight: normal;
  line-height: 1em;
  right: 0;
  z-index: 3;
  font-size: 0.625em;
}
dynamic-form .question.customValidation .dirty span.error {
  display: block;
}
dynamic-form dfq-yesno .radioWrap {
  display: inline-block;
  margin-right: 25px;
}
dynamic-form dfq-yesno .radioWrap label {
  display: block;
}
dynamic-form dfq-multiline {
  display: block;
  max-width: 400px;
}
dynamic-form dfq-multichoice visiba-input {
  margin: 10px 0;
}
dynamic-form .ng-submitted .question.customValidation span.error {
  display: block;
}
dynamic-form .navigation {
  text-align: center;
}
dynamic-form .navigation .back {
  left: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: var(--c_mainColorLight);
  font-size: 0.75em;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: all 200ms ease;
}
dynamic-form .navigation .back visiba-svg {
  width: 10px;
  margin-right: var(--m_elements);
  top: 4px;
  position: relative;
}
dynamic-form .navigation .pagination {
  font-size: 1.25em;
  color: var(--c_inputBorder);
}
dynamic-form .navigation .pagination span span {
  color: var(--c_textDark);
  font-weight: 600;
}
dynamic-form .navigation .abortLink {
  font-size: 0.75em;
}
dynamic-form .navigation .next,
dynamic-form .navigation .send {
  display: inline-block;
  min-width: 200px;
}
dynamic-form .navigation .row {
  margin: var(--m_components) 0 5px;
  position: relative;
}

/* ==========================================================================
#    Tablet CSS
   ========================================================================== */`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
